import type { IVedleggSak } from './IVedleggSak';

export class VedleggSak implements IVedleggSak {
    public get id() {
        return this._id;
    }

    public get fileName() {
        return this._fileName;
    }

    public get created() {
        return this._created;
    }

    public get saksmeldingId() {
        return this._saksmeldingId;
    }

    public get type() {
        return this._type;
    }

    public get fileSize() {
        // Formula to calculate size as file:
        const n = this._fileSize ? this._fileSize : this.fileContent.length;
        const l = this.fileContent.endsWith('==')
            ? n * (3 / 4) - 2
            : n * (3 / 4) - 1;
        return parseInt(l.toString(), 10);
    }

    public get fileContent() {
        return this._fileContent
            ? this._fileContent.toString().replace(/^data:(.*,)?/, '')
            : '';
    }

    public static parseObject(obj: IVedleggSak): VedleggSak {
        try {
            return new VedleggSak(obj);
        } catch (error) {
            throw new Error(`Could not parse object : ${JSON.stringify(obj)}`);
        }
    }

    readonly _id: IVedleggSak['id'];
    readonly _fileName: IVedleggSak['fileName'];
    readonly _created: IVedleggSak['created'];
    readonly _saksmeldingId: IVedleggSak['saksmeldingId'];
    readonly _type: IVedleggSak['type'];
    readonly _fileSize: IVedleggSak['fileSize'];
    readonly _fileContent: IVedleggSak['fileContent'];

    public constructor(obj: IVedleggSak) {
        this._id = obj.id;
        this._fileName = obj.fileName;
        this._created = obj.created;
        this._saksmeldingId = obj.saksmeldingId;
        this._type = obj.type;
        this._fileSize = obj.fileSize;
        this._fileContent = obj.fileContent;
    }

    public toVedleggSak = () => {
        const { fileContent, fileName, saksmeldingId, type, fileSize } = this;
        return {
            fileContent,
            fileName,
            saksmeldingId,
            type,
            fileSize,
        };
    };
}
